// Extracted from utils/insurance.ts: getFieldType (imported by the store's
// interview services) needs this regex, but insurance.ts also imports
// getField — pulling the whole file in from there formed a runtime circular
// dependency (store -> getSessionInterview -> getFieldType -> insurance ->
// getField -> field classes -> components -> store).
export const coiInputAttributeRegex =
    /risk_decisioning\.insurance_policy_verification\.self_attestation\..+\.input.document_scan/;
